import { Alert, Descriptions, Modal, Typography } from 'antd';
import { WarningCircle } from '@phosphor-icons/react';
import { CopyButton } from './StaffPage';
import { ROLE_LABELS, type CreateStaffResult } from './api';
import { tokens } from '../../theme';

/**
 * Mật khẩu tạm chỉ tồn tại đúng lần hiển thị này — server không lưu bản đọc được
 * và không có endpoint nào xem lại. Đóng modal là mất, muốn lấy lại phải đặt lại
 * mật khẩu (và cắt phiên của người đó). Cảnh báo phải nói rõ điều đó TRƯỚC khi đóng.
 */
export function TemporaryPasswordModal({
  issued,
  onClose,
}: {
  issued: CreateStaffResult | null;
  onClose: () => void;
}) {
  return (
    <Modal
      open={issued !== null}
      title="Mật khẩu tạm"
      okText="Tôi đã ghi lại"
      onOk={onClose}
      onCancel={onClose}
      cancelButtonProps={{ style: { display: 'none' } }}
      destroyOnHidden
    >
      {issued !== null && (
        <>
          <Alert
            type="warning"
            showIcon
            icon={<WarningCircle size={20} weight="fill" aria-hidden />}
            message="Mật khẩu này chỉ hiện một lần"
            description="Đóng cửa sổ là không xem lại được. Quên thì phải đặt lại mật khẩu, và thao tác đó cắt mọi phiên đang mở của nhân viên."
          />

          <div
            style={{
              margin: '16px 0',
              padding: tokens.space.cardPadding,
              background: tokens.color.surface2,
              borderRadius: tokens.radius.card,
              display: 'flex',
              alignItems: 'center',
              gap: 12,
            }}
          >
            <code
              style={{
                flex: 1,
                fontSize: 18,
                letterSpacing: '0.06em',
                userSelect: 'all',
                wordBreak: 'break-all',
              }}
            >
              {issued.temporaryPassword}
            </code>
            <CopyButton value={issued.temporaryPassword} label="mật khẩu tạm" />
          </div>

          <Descriptions size="small" column={1} bordered>
            <Descriptions.Item label="Tên đăng nhập">
              <code>{issued.staff.username}</code>
            </Descriptions.Item>
            <Descriptions.Item label="Họ và tên">{issued.staff.name}</Descriptions.Item>
            <Descriptions.Item label="Vai trò">{ROLE_LABELS[issued.staff.role]}</Descriptions.Item>
            <Descriptions.Item label="Chi nhánh">
              {issued.staff.branchName ?? 'Toàn hệ thống'}
            </Descriptions.Item>
          </Descriptions>

          <Typography.Paragraph style={{ marginTop: 12, marginBottom: 0, fontSize: 12, color: tokens.color.ink2 }}>
            Nhân viên buộc đổi mật khẩu ngay ở lần đăng nhập đầu tiên.
          </Typography.Paragraph>
        </>
      )}
    </Modal>
  );
}
